import React, { useContext, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import LocationIcon from '../images/location.svg'
import { Seo } from "../../components/common";
import styled from "styled-components";
import { ThemeContext } from "../../providers/ThemeProvider";
import YouTubeComponent from './partials/YouTubeComponent';

const MainContentContainer = styled.div`
    background: ${({ theme }) => (theme === 'light' ? '#fff' : 'transparent')};
    color: ${({ theme }) => (theme === 'light' ? 'rgba(0,0,0,.84)' : 'rgb(230, 230, 230)')};
    h2 {
        border-bottom: ${({ theme }) => (theme === 'light' ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(255,255,255,0.5)')};
    }
`

const EventsContainer = styled.main`
  background: ${({ theme }) => (theme === 'light' ? '#fff' : 'transparent')};
  max-width: 1000px;
  padding: 0 3%;
  margin: 0 auto;
  font-size: 18px;

  h3 {
    font-family: 'SF Pro Text Light', sans-serif;
    font-size: 22px;
    font-weight: 400;
  }

  p {
    line-height: 1.58;
  }

  p.location {
    font-family: 'SF Pro Text Regular', sans-serif;
    font-size: 15px;
  }

  div.event-detail {
    margin-left: 3px;
    padding: 0 1em;
    box-sizing: border-box;
  }

  div.event-container:not(:last-of-type)::after {
    content: ""; // This is necessary for the pseudo element to work.
    display: block; // This will put the pseudo element on its own line. 
    padding-top: 2em;
    margin: 0 auto 3em auto; // Center the border
    width: 50%;
    border-bottom: ${({ theme }) => (theme === 'light' ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(255,255,255,0.2)')};
  }

  @media only screen and (min-width: 481px) {
    div.event-container {
      margin: 2em 0;
    }

    p.location {
      text-align: right;
      margin: -1em 0 -0.5em 0;
    }
  }

  img.location-icon {
    height: 18px;
    margin-right: 5px;
    // Make the icon vertically align with the text
    padding-bottom: 3px;
    vertical-align: middle;
  }

  // Styles in div.video-container and iframe are derived from 'https://www.h3xed.com/web-development/how-to-make-a-responsive-100-width-youtube-iframe-embed'
  // to make the embeded Youtube video responsive.
  div.video-container {
    position: relative;
    width: 100%;
    height: 0;
    // padding-bottom controls the height of the video, the video is hidden if its value is 0, 
    padding-bottom: 44%;
  }

  // Local Video
  video {
    width: 100%;
    max-height: 400px;
    max-width: 650px;
  }

  // Youtube Video
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const Events = ({ events, lang }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const { theme } = useContext(ThemeContext);
  const { seoTitle, seoTitleCN, items } = events
  const isEn = lang === "en"
  const seoList = items.map(event => isEn ? event.introduction : event.introductionCN)
  return (
    <MainContentContainer theme={theme}>
      <EventsContainer theme={theme}>
        <Seo title={isEn ? seoTitle : seoTitleCN}
          description={seoList.join(" ")}
          location={isEn ? "/events" : "/cn/events"}
          lang={lang}
        />
        <h2>{isEn ? "Some Events" : "部分学术活动"}</h2>
        {items.map((event, idx) =>
          <div className='event-container' key={idx}>
            <h3 className='subject'>{isEn ? event.subject : event.subjectCN}</h3>
            <div className='event-detail'>
              <p className='location'>
                <img className='location-icon' src={LocationIcon} alt='location' />
                {isEn ? event.location : event.locationCN}
              </p>
              <ReactMarkdown
                className='introduction'
                children={isEn ? event.introduction : event.introductionCN}
                // components={{link: this.LinkRenderer}}
                linkTarget={"_blank"}
                rel="noopener noreferrer"
              />
              {event.youtubeId &&
                <div className='video-container'>
                  <YouTubeComponent youtubeId={event.youtubeId} isEn={isEn} />
                </div>
              }
            </div>
          </div>
        )}
      </EventsContainer>
    </MainContentContainer>
  )
}

export default Events